import { get } from './methods';

export default {
  download: (idDocumento: number) => {
    const endpoint = `documento/${idDocumento}/download`;
    return get<ArrayBuffer>(endpoint, { responseType: 'arraybuffer' });
  },
}

export const documentoServiceDownload = (
  codigo: string
): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    return get<ArrayBuffer>(`documento/${codigo}`, {
      responseType: 'arraybuffer',
    }).then(
      (response) => {
        resolve(response.data as ArrayBuffer);
      },
      (error) => {
        reject(error);
      },
    );
  });
};

export interface DocumentoResponse {
  idDocumento: number;
  codigo: string;
  nome: string;
  descricao: string;
  tipoDocumento: string;
  flgVisivelAssociado: boolean;
}